import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertStatus,
  AlertTitle,
  CloseButton,
  StyleProps,
} from "@chakra-ui/react";
import React from "react";
import { RiInformationFill } from "react-icons/ri";

type Props = {
  title?: string;
  status?: AlertStatus;
  children: React.ReactNode;
  closeAlert?: () => void;
  styleProps?: StyleProps;
};
export const InfoAlert: React.FC<Props> = ({
  children,
  status,
  closeAlert,
  title,
  styleProps,
}) => {
  return (
    <Alert
      status={status ? status : "info"}
      borderRadius={6}
      alignItems="flex-center"
      sx={styleProps}
    >
      <AlertIcon as={RiInformationFill} />
      {title ? <AlertTitle>{title}</AlertTitle> : null}
      <AlertDescription flexGrow={1}>{children}</AlertDescription>
      {closeAlert ? <CloseButton onClick={closeAlert} /> : null}
    </Alert>
  );
};
